// Win probability calculation utility

export const STAGE_PROBABILITY = {
    "New": [0, 10],
    "Contacted": [10, 20],
    "Qualified": [30, 50],
    "Not Qualified": [0, 0],       // Disqualified - 0% win probability
    "Proposal Sent": [75, 90],
    "Closed Won": [100, 100],
};

export const ENGAGEMENT_FACTORS = {
    "Meeting with decision-maker": 25,
    "Email reply from prospect": 20,
    "Content download": 15,
    "CRM stage progression": 20,
    "Social media interaction": 10,
    "Website visit frequency": 10,
};

export function calculateWinProbability(stage, engagement = []) {
    const [min, max] = STAGE_PROBABILITY[stage] || [0, 0];
    let base = Math.round((min + max) / 2);
    let engagementScore = 0;
    if (Array.isArray(engagement)) {
        engagement.forEach(e => {
            engagementScore += ENGAGEMENT_FACTORS[e] || 0;
        });
    }
    return Math.min(100, base + engagementScore);
}